import { render, staticRenderFns } from "./AssignDocumentsModal.vue?vue&type=template&id=cc463e48&scoped=true&"
import script from "./AssignDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./AssignDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignDocumentsModal.vue?vue&type=style&index=0&id=cc463e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc463e48",
  null
  
)

export default component.exports